import { mapActions } from 'vuex';
import tabs from '@/components/generics/tabs/tabs.vue';
import ach from '@/components/wallet/ach/ach.vue';
import check from '@/components/wallet/check/check.vue';
import bankTransfer from '@/components/wallet/bank-transfer/bank-transfer.vue';
import coinbaseWithdraw from '@/components/wallet/coinbase-withdraw/coinbase-withdraw.vue';
import pendingRequests from '@/components/wallet/pending-requests/pending-requests.vue';
import loaderMixin from '@/mixins/loader';

const TAB_ACH = 'ach';
const TAB_CHECK = 'check';
const TAB_COIN_BASE = 'coinbase';
const TAB_PENDING_REQUESTS = 'pending';
const TAB_BANK_TRANSFER = 'bank-transfer';
const GTM_PAGE_NAME = 'withdraw';

export default {
  mixins: [
    loaderMixin,
  ],
  components: {
    ach,
    check,
    bankTransfer,
    coinbaseWithdraw,
    pendingRequests,
    tabs,
  },
  data() {
    return {
      cryptoDesctiption: '',
      showTabs: false,
      activeTab: null,
      isCryptoAvailable: false,
      isCheckAvailable: false,
      isAchAvailable: false,
      isWireTransferAvailable: false,
    };
  },
  computed: {
    showAchTab() {
      return this.activeTab === TAB_ACH;
    },
    showCheckTab() {
      return this.activeTab === TAB_CHECK;
    },
    showPendingTab() {
      return this.activeTab === TAB_PENDING_REQUESTS;
    },
    showCryptoTab() {
      return this.activeTab === TAB_COIN_BASE;
    },
    showBankTransferTab() {
      return this.activeTab === TAB_BANK_TRANSFER;
    },
    tabs() {
      const results = [];
      if (this.isAchAvailable) {
        results.push({
          name: TAB_ACH,
          title: 'ACH',
        });
      }
      if (this.isCheckAvailable) {
        results.push({
          name: TAB_CHECK,
          title: 'Check',
        });
      }
      if (this.isCryptoAvailable) {
        results.push({
          name: TAB_COIN_BASE,
          title: this.cryptoDesctiption,
        });
      }
      if (this.isWireTransferAvailable) {
        results.push({
          name: TAB_BANK_TRANSFER,
          title: 'Wire Transfer',
        });
      }
      results.push({ name: TAB_PENDING_REQUESTS, title: 'Pending' });
      return results;
    },
  },
  methods: {
    ...mapActions('wallet', ['getWithdrawalMethods']),
    onSuccessWithdraw() {
      this.activeTab = TAB_PENDING_REQUESTS;
    },
    tabChange(name) {
      this.activeTab = name;

      if (this.$route && this.$route.path) {
        this.$gtm.trackEvent({
          event: 'pageviewTrackerEvent',
          virtualPage: `${this.$route.path}/${GTM_PAGE_NAME}/${name}`,
          virtualPageTitle: `${this.$route.name} - ${GTM_PAGE_NAME} - ${name}`,
        });
      }
    },
  },
  created() {
    this.loaderAdd(document.body);
    this.getWithdrawalMethods()
      .then((data) => {
        this.showTabs = true;
        this.isCheckAvailable = data.isCheckAvailable;
        this.isAchAvailable = data.isAchAvailable;
        this.isWireTransferAvailable = data.isWireTransferAvailable;
        this.isCryptoAvailable = data.isCryptoAvailable;
        this.cryptoDesctiption = data.cryptoDescription || 'USDC';
        this.loaderRemove(document.body);
      })
      .catch(() => this.loaderRemove(document.body));
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/withdraw/withdraw.js